export const awards = [
    {
        id: 1,
        name: "Best Outgoing Student 2022",
        by: "Electronics & Telecommunication Department, Goa College of Engineering"
    },
    {
        id: 2,
        name: "GHC'21 Scholar",
        by: "Anita.org"
    },
    {
        id: 3,
        name: "State Subject Topper",
        by: "Rajhauns | SSC Goa Board"
    },
    {
        id: 4,
        name: "Most Promising Student",
        by: "Holy Family High School"
    }, 
    {
        id: 5,
        name: "Most Hardworking Student",
        by: "Holy Family High School"
    } 
]